"use strict";

const burgerMenu = document.getElementById('burger-menu');
const menu = document.getElementById('menu');

burgerMenu.addEventListener('click', function() {
    menu.classList.toggle('active');
    burgerMenu.classList.toggle('open');
})

//AIDE IA POUR SCROLL NAV

let lastScrollTop = 0;
const borderNav = document.querySelector(".border-nav");

window.addEventListener("scroll", () => {
    let scrollTop = window.scrollY;

    if (scrollTop > lastScrollTop && scrollTop > 50) {
        // Scroll vers le bas → cacher la navbar
        borderNav.classList.add("hidden");
    } else {
        // Scroll vers le haut → montrer la navbar
        borderNav.classList.remove("hidden");
    }

    lastScrollTop = scrollTop;
});